module.exports = __webpack_public_path__ + "img/lens-report-top.7f9d9fe1.png";